exports = module.exports = require("C:\\Users\\kop\\Repos\\webpack\\node_modules\\css-loader\\cssToString.js")();
exports.push([module.id, "body{color:#abc}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/css-loader!./parsing/bom/bomfile.css
 ** module id = 2
 ** module chunks = 0
 **/